export const formatFileSubtext = (
    fileType: string,
    fileSize?: string
): string => {
    const type = fileType.trim();
    if (!type) {
        return "";
    }

    const size = fileSize?.trim() ?? "";
    return size ? `${type} | ${size}` : type;
};

export const isVideoFileType = (fileType: string): boolean =>
    fileType.trim().toLowerCase() === "video";
